import React from 'react'
import ChartFlexSection from '@components/chart/ChartFlexSection'
import TextChartTitle from '@components/text/TextChartTitle'
import { Progress, Table } from '@mantine/core'
import TableHeaderColumn from '@components/table/template/TableHeaderColumn'
import { IResponseOptAgencyBudgetRanking } from '@interfaces/api/IDashboard'
import { Money, Num } from '@utils/utils'

const AgencyBudgetRanking = ({ title, data }: { title: string; data: IResponseOptAgencyBudgetRanking }) => {
  return (
    <ChartFlexSection className="pagebreak">
      <TextChartTitle>{title}</TextChartTitle>
      <Table pos={'relative'}>
        <thead>
          <tr>
            <TableHeaderColumn label={'อันดับ'} width={'0%'} />
            <TableHeaderColumn label={'หน่วยงาน'} width={'25%'} />
            <TableHeaderColumn label={'จำนวนโครงการ'} width={'10%'} />
            <TableHeaderColumn label={'มูลค่าโครงการ'} width={'10%'} />
            <TableHeaderColumn label={''} width={'40%'} />
          </tr>
        </thead>
        <tbody>
          {data.map((p) => (
            <tr key={p.rank_no}>
              <td>{p.rank_no}</td>
              <td>{p.agency_name}</td>
              <td>{Num(p.total_projects)}</td>
              <td>{Money(p.total_budget)}</td>
              <td>
                <Progress
                  w="100%"
                  size="xl"
                  sections={[
                    {
                      value: parseFloat(p.total_budget) / (parseFloat(data[0].total_budget) / 100),
                      color: 'blue',
                    },
                  ]}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </ChartFlexSection>
  )
}

export default AgencyBudgetRanking
